import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/images/logo-sm.png';
import _imports_1 from '@/assets/images/logo-dark.png';
import _imports_2 from '@/assets/images/logo-light.png';
const _hoisted_1 = { class: "main-nav" };
const _hoisted_2 = {
    class: "scrollbar",
    "data-simplebar": "",
    ref: "sidebarScrollbar"
};
const _hoisted_3 = {
    class: "navbar-nav",
    id: "navbar-nav"
};
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = {
    key: 0,
    class: "menu-title-icon me-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SectionSelector = _resolveComponent("SectionSelector");
    const _component_MenuItem = _resolveComponent("MenuItem");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"logo-box\" data-v-8ea08f02><a class=\"logo-dark\" href=\"/\" data-v-8ea08f02><img alt=\"logo sm\" class=\"logo-sm\" src=\"" + _imports_0 + "\" data-v-8ea08f02><img alt=\"logo dark\" class=\"logo-lg\" src=\"" + _imports_1 + "\" data-v-8ea08f02></a><a class=\"logo-light\" href=\"/\" data-v-8ea08f02><img alt=\"logo sm\" class=\"logo-sm\" src=\"" + _imports_0 + "\" data-v-8ea08f02><img alt=\"logo light\" class=\"logo-lg\" src=\"" + _imports_2 + "\" data-v-8ea08f02></a></div>", 1)),
        _createElementVNode("button", {
            "aria-label": "Show Full Sidebar",
            class: "button-sm-hover",
            style: { "transform": "rotate(180deg)" },
            type: "button",
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => ($setup.toggleHoverSidebar && $setup.toggleHoverSidebar(...args)))
        }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "ri-menu-2-line fs-24 button-sm-hover-icon" }, null, -1)
            ]))]),
        _createVNode(_component_SectionSelector),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuItems, (section, sectionIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: sectionIndex }, [
                        (section.title && !section.hidden)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 0,
                                class: _normalizeClass(["menu-title d-flex justify-content-between align-items-center", { 'disabled': section.disabled }])
                            }, [
                                _createElementVNode("span", _hoisted_4, [
                                    (section.icon)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                            _createElementVNode("i", {
                                                class: _normalizeClass(section.icon)
                                            }, null, 2)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(section.title), 1)
                                ]),
                                (section.badge)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass(['badge', section.badge.class, 'badge-pill'])
                                    }, _toDisplayString(section.badge.text), 3))
                                    : _createCommentVNode("", true)
                            ], 2))
                            : _createCommentVNode("", true),
                        (section.items && !section.hidden)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(section.items, (item, itemIndex) => {
                                return (_openBlock(), _createBlock(_component_MenuItem, {
                                    key: itemIndex,
                                    item: item,
                                    "section-disabled": section.disabled || false
                                }, null, 8, ["item", "section-disabled"]));
                            }), 128))
                            : _createCommentVNode("", true)
                    ], 64));
                }), 128))
            ])
        ], 512)
    ]));
}
